var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"checkpoint-circle",attrs:{"src":_vm.active ? _vm.$options.colored : _vm.$options.grey,"width":"52px","height":"52px"}})}
var staticRenderFns = []

export { render, staticRenderFns }